/* eslint-disable */
export default {
  title: 'Audio',
  input: 'Entrada',
  microphone: 'Micrófono',
  autoAdjustMicLevel: 'Ajustar automáticamente el nivel del micrófono',
  output: 'Salida',
  speakerSource: 'Origen de altavoz',
  speakerVolume: 'Volumen del altavoz',
  ringtoneSource: 'Origen de las notificaciones y el tono de llamada',
  ringtoneVolume: 'Volumen de las notificaciones y el tono de llamada',
  ringtones: 'Tonos',
  noDevices: 'No hay dispositivos',
  off: 'Desactivado',
  noLabel: 'Dispositivo desconocido',
  stopRecordDescription:
    'Diga algo para comprobar el nivel de su micrófono ({countDown} segundo/s)',
  stopPlaybackDescription: 'Reproduciendo su grabación...',
  startRecordButton: 'Probar micrófono',
  stopRecordButton: 'Detener grabación',
  stopPlaybackButton: 'Detener prueba',
  startTestButton: 'Probar altavoz',
  stopTestDescription: 'Reproduciendo sonido de muestra...',
} as const;

// @key: @#@"title"@#@ @source: @#@"Audio"@#@
// @key: @#@"input"@#@ @source: @#@"Input"@#@
// @key: @#@"microphone"@#@ @source: @#@"Microphone"@#@
// @key: @#@"autoAdjustMicLevel"@#@ @source: @#@"Automatically adjust my mic level"@#@
// @key: @#@"output"@#@ @source: @#@"Output"@#@
// @key: @#@"speakerSource"@#@ @source: @#@"Speaker source"@#@
// @key: @#@"speakerVolume"@#@ @source: @#@"Speaker volume"@#@
// @key: @#@"ringtoneSource"@#@ @source: @#@"Ringtone and notification source"@#@
// @key: @#@"ringtoneVolume"@#@ @source: @#@"Ringtone and notification volume"@#@
// @key: @#@"ringtones"@#@ @source: @#@"Ringtones"@#@
// @key: @#@"noDevices"@#@ @source: @#@"No devices"@#@
// @key: @#@"off"@#@ @source: @#@"Off"@#@
// @key: @#@"noLabel"@#@ @source: @#@"Unknown device"@#@
// @key: @#@"stopRecordDescription"@#@ @source: @#@"Say something to check your mic level ({countDown} sec)"@#@
// @key: @#@"stopPlaybackDescription"@#@ @source: @#@"Playing your recording..."@#@
// @key: @#@"startRecordButton"@#@ @source: @#@"Test microphone"@#@
// @key: @#@"stopRecordButton"@#@ @source: @#@"Stop recording"@#@
// @key: @#@"stopPlaybackButton"@#@ @source: @#@"Stop test"@#@
// @key: @#@"startTestButton"@#@ @source: @#@"Test speaker"@#@
// @key: @#@"stopTestDescription"@#@ @source: @#@"Playing sample sound..."@#@
